import { render, staticRenderFns } from "./edit-video.vue?vue&type=template&id=6f86a8a8&scoped=true&"
import script from "./edit-video.vue?vue&type=script&lang=js&"
export * from "./edit-video.vue?vue&type=script&lang=js&"
import style0 from "./edit-video.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./edit-video.vue?vue&type=style&index=1&id=6f86a8a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f86a8a8",
  null
  
)

export default component.exports